import { RECURRING_TABLE_FREQUENCY } from './constants'

export const getTimeInMillis = (datetime) => {
  if (datetime) {
    return new Date(datetime).getTime()
  } else {
    return new Date().getTime()
  }
}

export const formattedDate = (dt) => {
  const d = new Date(dt)
  return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${d.getFullYear()}`
}

export const timePassed = (startTime, endTime = new Date()) => {
  const start = new Date(startTime)
  const end = new Date(endTime)
  const seconds = Math.floor((end - start) / 1000)

  if (seconds < 60) return `${seconds} sec ago`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} hr ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days} day${days > 1 ? 's' : ''} ago`
  const weeks = Math.floor(days / 7)
  if (weeks < 4) return `${weeks} week${weeks > 1 ? 's' : ''} ago`
  const months = Math.floor(days / 30)
  if (months < 12) return `${months} month${months > 1 ? 's' : ''} ago`
  const years = Math.floor(days / 365)
  return `${years} year${years > 1 ? 's' : ''} ago`
}

export const formatRecurringPeriod = (startDate, endDate) => {
  const formatDate = (date) =>
    new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })

  return `${formatDate(startDate)} - ${formatDate(endDate)}`
}

export const getRecurringPeriod = (datetime, frequency) => {
  const date = new Date(datetime)

  if (Number.isNaN(date.getTime())) {
    return {
      startDate: null,
      endDate: null,
      rangeText: '',
    }
  }

  const startDate = new Date(date)
  const endDate = new Date(date)

  switch (frequency) {
    case RECURRING_TABLE_FREQUENCY.DAILY:
      break

    case RECURRING_TABLE_FREQUENCY.WEEKLY:
      endDate.setDate(endDate.getDate() + 6)
      break

    case RECURRING_TABLE_FREQUENCY.MONTHLY:
      endDate.setMonth(endDate.getMonth() + 1, 0)
      break

    case RECURRING_TABLE_FREQUENCY.QUARTERLY:
      endDate.setMonth(endDate.getMonth() + 3, 0)
      break

    case RECURRING_TABLE_FREQUENCY.BIANNUAL:
      endDate.setMonth(endDate.getMonth() + 6, 0)
      break

    case RECURRING_TABLE_FREQUENCY.ANNUAL:
      endDate.setFullYear(endDate.getFullYear() + 1)
      endDate.setDate(0)
      break

    default:
      return {
        startDate: null,
        endDate: null,
        rangeText: '',
      }
  }

  return {
    startDate,
    endDate,
    rangeText: formatRecurringPeriod(startDate, endDate),
  }
}
